const drawerLeft = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M5.51 1h9.43v1.57H5.51zm0 12.43h9.43V15H5.51zM0 8.05 4.55 3.5v3.72h10.455v1.56H4.55v3.83z"/></svg>',
};

export { drawerLeft as default };
